import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-nead-ink text-white">
        <div className="animate-pulse text-sm tracking-widest uppercase text-white/60">Loading…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}
